import { Configuration } from '@/types';
import ConfigurationTreeView from '@/components/configuration/TreeView.vue';
import { RouteHelpers } from '@/mixins';
import { TreeViewConstants } from '@/types/constants/TreeViewConstants';

const ScriveEditSigningPartyFieldPlacement = () =>
  import(
    /* webpackChunkName: "ScriveSigningPartyFieldPlacement" */
    '@/views/configuration/scrive/ScriveEditSigningPartyFieldPlacement.vue'
  );

const ScriveAddSigningPartyFieldPlacement = () =>
  import(
    /* webpackChunkName: "ScriveSigningPartyFieldPlacement" */
    '@/views/configuration/scrive/ScriveAddSigningPartyFieldPlacement.vue'
  );

const meta = {
  layout: 'TreeView',
  treePath: 'scrivetemplates',
  treeViewKey: TreeViewConstants.Keys.Configuration,
  title: 'Scrive Templates'
};

const treeView = {
  treeView: ConfigurationTreeView
};

export const SigningPartyFieldPlacementRoutes = [
  {
    ...Configuration.Scrive.SigningPartyFieldPlacement.Edit,
    components: {
      default: ScriveEditSigningPartyFieldPlacement,
      ...treeView
    },
    meta,
    beforeEnter: (to: any, from: any, next: any) => {
      RouteHelpers.setErrorPageRedirect(Configuration.Scrive.Template.Management.name);
      RouteHelpers.beforeEnterCheckRouteParamAsNumeric(to, from, next, ['documentTypeId', 'templateId', 'signingPartyId', 'signingPartyFieldId', 'id']);
    }
  },
  {
    ...Configuration.Scrive.SigningPartyFieldPlacement.Add,
    components: {
      default: ScriveAddSigningPartyFieldPlacement,
      ...treeView
    },
    meta,
    beforeEnter: (to: any, from: any, next: any) => {
      RouteHelpers.setErrorPageRedirect(Configuration.Scrive.Template.Management.name);
      RouteHelpers.beforeEnterCheckRouteParamAsNumeric(to, from, next, ['documentTypeId', 'templateId', 'signingPartyId', 'signingPartyFieldId']);
    }
  }
];
